import { Store, Package, Sparkles, MessageCircle, LucideIcon } from "lucide-react";
import { memo } from "react";

interface Step {
  number: string;
  icon: LucideIcon;
  title: string;
  description: string;
}

const steps: Step[] = [
  {
    number: "01",
    icon: Store,
    title: "Cadastre sua Loja",
    description: "Crie sua conta grátis e configure sua loja em minutos."
  },
  {
    number: "02",
    icon: Package,
    title: "Adicione suas Peças",
    description: "Faça upload das fotos dos seus produtos de forma simples."
  },
  {
    number: "03",
    icon: Sparkles,
    title: "Gere Imagens com IA",
    description: "Escolha o modelo e cenário. A IA faz o resto!"
  },
  {
    number: "04",
    icon: MessageCircle,
    title: "Venda pelo WhatsApp",
    description: "Compartilhe seu catálogo e receba pedidos direto no Zap."
  }
];

const StepCard = memo(function StepCard({ step, isLast }: { step: Step; isLast: boolean }) {
  const Icon = step.icon;
  return (
    <div className="relative">
      {/* Connector line */}
      {!isLast && (
        <div className="hidden lg:block absolute top-12 left-1/2 w-full h-px bg-gradient-to-r from-primary/50 to-transparent" />
      )}

      <div className="relative bg-card rounded-2xl border border-border p-6 hover:border-primary/50 transition-all duration-300">
        {/* Number badge */}
        <div className="absolute -top-4 left-6 bg-primary text-primary-foreground px-3 py-1 rounded-full text-sm font-bold">
          {step.number}
        </div>

        <div className="pt-4">
          <div className="w-12 h-12 rounded-xl bg-accent flex items-center justify-center mb-4">
            <Icon className="w-6 h-6 text-primary" />
          </div>
          <h3 className="text-base font-semibold mb-2">{step.title}</h3>
          <p className="text-sm text-muted-foreground">{step.description}</p>
        </div>
      </div>
    </div>
  );
});

export const HowItWorksSection = memo(function HowItWorksSection() {
  return (
    <section id="como-funciona" className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Como <span className="text-gradient">funciona</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Em 4 passos simples você transforma sua loja
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <StepCard key={step.number} step={step} isLast={index === steps.length - 1} />
          ))}
        </div>
      </div>
    </section>
  );
});
